<template>
	<div>
		<input v-for="input in file_inputs"
			   :id="input.id"
			   v-on:change="uploadNewFile"
			   v-on:click="blockInteraction"
			   type="file"
			   :name="input.name"
			   v-bind:disabled="disabled"
			   class="d-none"/>
		<button :class="button_class" v-on:click="openDialog()">{{label}}</button>
	</div>
</template>

<script>
	export default {
		name: "UploadImageButton",
		props: [
			'button_class',
			'label',
			'disable_data_encode',
			'disabled'
		],

		data(){
			return {
				indexer: 0,
				file_inputs: [],
			}
		},

		methods: {
			blockInteraction (e){
				if (e.target.files.length){
					e.preventDefault();
					return;
				}
			},

			uploadNewFile(e){
				let files_in_input = e.target.files || e.dataTransfer.files;

				if (!files_in_input.length){
					if (typeof e.target.remove === 'function') {
						e.target.remove();
					} else {
						e.target.parentNode.removeChild(e.target);
					}
					return;
				}

				if (this.disable_data_encode){
					//Disable parsing and reading of the file (maybe a video or text file)
					this.$emit('input', true);
					this.$emit('file', files_in_input[0]);

					return;
				}

				let
					_this = this,
					reader = new FileReader();

				reader.onload = function (e) {
					_this.$emit('input', e.target.result);
					_this.$emit('file', files_in_input[0]);
				};
				reader.readAsDataURL(files_in_input[0]);
			},

			openDialog(){
				let _this = this;

				_this.indexer ++;

				_this.file_inputs.push({
					id: 'file_uploader-' +_this.indexer,
					name: 'file-' + _this.indexer
				});

				window.setTimeout(function (){
					document.getElementById('file_uploader-' + _this.indexer).click();

					document.body.onfocus = function(){
						document.body.onfocus = null;

						window.setTimeout(function (){
							if (document.getElementById('file_uploader-' + _this.indexer).files.length === 0){
								_this.file_inputs.pop();
							}
						}, 500);
					};
				}, 150);
			},
		}
	}
</script>